import {
  FollowUpLinkType,
  FollowUpType,
} from '@app/modules/follow-ups/follow-ups.types';
import { ApiHeaders } from '@core/core.types';
import { FollowUpsFilters } from './follow-ups.state';

export class GetFollowUpsListAction {
  static type = '[FollowUps] GetFollowUpsListAction';
  constructor(
    public filters: FollowUpsFilters,
    public headers: ApiHeaders,
    public pageToLoad: number,
    public reload: boolean
  ) {}
}

export class GetFollowUpsUsersListAction {
  static type = '[FollowUps] GetFollowUpsUsersListAction';
  constructor() {}
}

export class GetFollowUpAction {
  static type = '[FollowUps] GetFollowUpAction';
  constructor(public followUpId: string) {}
}

export class CreateFollowUpsAction {
  static type = '[FollowUps] CreateFollowUpsAction';
  constructor(
    public ids: string[],
    public linkType: FollowUpLinkType,
    public type: FollowUpType,
    public reason: string
  ) {}
}

export class ArchiveFollowUpsAction {
  static type = '[FollowUps] ArchiveFollowUpsAction';

  constructor(public followUpIds: string[]) {}
}

export class DeleteFollowUpAction {
  static type = '[FollowUps] DeleteFollowUpAction';

  constructor(public followUpId: string) {}
}

export class AssignFollowUpsAction {
  static type = '[FollowUps] AssignFollowUpsAction';

  constructor(
    public followUpIds: string[],
    public assigneeId: string
  ) {}
}

export class ResolveFollowUpsAction {
  static type = '[FollowUps] ResolveFollowUpsAction';

  constructor(public followUpIds: string[]) {}
}

export class SetFollowUpNotesAction {
  static type = '[FollowUps] SetFollowUpNotesAction';

  constructor(
    public followUpId: string,
    public notes: string
  ) {}
}
